<!-- ./src/pages/admin/Products.vue -->

<template src="./Dividas.html"></template>

<script>
  import store from "@/store";
  import axios from "axios";
  import { mapMutations } from "vuex";
  import usuarioCtrl from "@/services/usuario";
  import dividasCtrl from "@/services/dividas";
  import clienteCtrl from "@/services/cliente";
  import enderecodeveCtrl from "@/services/enderecodeve";
  import devedoresCtrl from "@/services/devedores";
  import telefonedeveCtrl from "@/services/telefonedeve";
  import buscacep from "@/services/buscacep";
  import emaildeve from "@/services/emaildeve";
  import moment from "moment";
  import {VMoney} from 'v-money'
  import {json2excel, excel2json} from 'js2excel';

  function csvJSON(csv){
    var lines=csv.split("\n");
    
    var result = [];
    let countcoma = lines[0].match(/,/g);
    let countpont = lines[0].match(/;/g);
    let char = ',';
    if (countcoma && countpont) {
      char = countcoma.length>countpont.length?',':';';
    } else {
      char = (countcoma)?',':';';
    }
    for(var i=1;i<lines.length;i++){
      lines[i] = lines[i].trim();
    }
    
    var headers=lines[0].split(char);
    for(var i=1;i<lines.length;i++){
      var obj = {};
      var currentline=lines[i].split(char);
      for(var j=0;j<headers.length;j++){
        obj[headers[j].trim()] = currentline[j];
      }
      result.push(obj);
    }
    return result; //JSON
  }

  export default {
    name: 'home',
    data () {
      return {
        active: 0,
        search: '',
        filtros: {},
        clientes: [],
        message: '',
        problemas: '',
        tarefa: '',
        dialog: false,
        dialogNovo: false,
        dialogImport: false,
        menu: false,
        dialogError: false,
        dialogConfirmation: false,
        editando: false,
        carregando: false,
        user: null,
        excluindo: {},
        importaCliente: null,
        parseCsv: [],
        usuarios: [],
        dividas: [],
        filtered: [],
        clientes: [],
        
        tipo: 'cpf',
        maskCEP: '#####-###',
        maskData: '##/##/####',
        maskCPF: '###.###.###-##',
        maskCNPJ: '##.###.###/####-##',
        mask: '(##) #####-####',

        money: {
          decimal: ',',
          thousands: '.',
          suffix: '',
          precision: 2
        },
        model: {
          nome: '',
          usuarios: [],
          etapas: []
        },
        tipoProdutos: [
          {
            tipoProduto: 1,
            descricao: "BOLETO"
          },
          {
            tipoProduto: 2,
            descricao: "CHEQUE"
          },
          {
            tipoProduto: 3,
            descricao: "NOTA"
          },
          {
            tipoProduto: 4,
            descricao: "NOTA FISCAL"
          },
          {
            tipoProduto: 5,
            descricao: "PROMISSORIA"
          }
        ],
        tipoJuros: [
          {
            tipoJuro: 1,
            descricao: "Dia"
          },
          {
            tipoJuro: 2,
            descricao: "Mês"
          },
          {
            tipoJuro: 3,
            descricao: "Ano"
          }
        ],
        headers: [{
            text: 'Empresa',
            align: 'left',
            sortable: true,
            value: 'idcliente.Nome'
          },{
            text: 'Devedor',
            align: 'left',
            sortable: true,
            value: 'iddevedor.Nome'
          },{
            text: 'Status Divida',
            align: 'left',
            sortable: true,
            value: 'StatusDivida'
          },{
            text: 'Valor Divida',
            align: 'left',
            sortable: true,
            value: 'ValorDivida'
          },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        
        headersPdfs: [{
            text: 'Nome  Anexo',
            align: 'left',
            sortable: true,
            value: 'descricao',
          },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        headersCsv: [{
            text: 'Nome',
            align: 'left',
            sortable: true,
            value: 'Nome'
          },{
            text: 'CPF',
            align: 'left',
            sortable: true,
            value: 'CnpjCpf'
          },{
            text: 'DataNascimento',
            align: 'left',
            sortable: true,
            value: 'DataNascimento'
          },{
            text: 'Endereco',
            align: 'left',
            sortable: true,
            value: 'Endereco'
          },{
            text: 'contrato',
            align: 'left',
            sortable: true,
            value: 'contrato'
          },{
            text: 'ValorDivida',
            align: 'left',
            sortable: true,
            value: 'ValorDivida'
          },{
            text: 'ValorEmpresa',
            align: 'left',
            sortable: true,
            value: 'ValorEmpresa'
          },{
            text: 'status',
            align: 'left',
            sortable: true,
            value: 'status'
          },{
            text: 'DataDivida',
            align: 'left',
            sortable: true,
            value: 'DataDivida'
          },{
            text: 'Especificacao',
            align: 'left',
            sortable: true,
            value: 'Especificacao'
          },{
            text: 'Juros',
            align: 'left',
            sortable: true,
            value: 'Juros'
          },{
            text: 'Tipo Juros',
            align: 'left',
            sortable: true,
            value: 'TipoJuros'
          }
        ]
      }
    },
    computed: {
      computedDateInicio () {
        return this.model.dtInicio ? moment(this.model.dtInicio).format('DD/MM/YYYY') : ''
      }
    },
    async created () {
      this.setLoading(true);
      this.clientes = await clienteCtrl.getClientes();
      await this.buscarDividas();
      this.setLoading(false);
    },
    methods: {
      async freteCep (postcode) {
        this.cep = await buscacep.getCep(postcode.replace('-', ''));

        this.model.logradouro = this.cep.logradouro;
        this.model.bairro = this.cep.bairro;
        this.model.localidade = this.cep.localidade;
        this.model.uf = this.cep.uf;
        this.$forceUpdate();
      },
      buscarDividas: async function () {
        this.setLoading(true);
        if (store.getters.user) {
          this.user = await usuarioCtrl.getUsuario(store.getters.user._id);
          if (this.user != null && this.user.acesso == "Cliente") {
            this.dividas = await dividasCtrl.getDividas({cliente: this.user.cliente, filtros: this.filtros});
          } else {
            this.dividas = await dividasCtrl.getDividas({filtros: this.filtros});
          }
        }
        this.setLoading(false);
      },
      novo: async function () {
        this.dialogNovo = true;
        this.editando = false;
        // this.$refs.ValorDivida.$el.getElementsByTagName('input')[0].value = 0;
        // this.$refs.ValorEmpresa.$el.getElementsByTagName('input')[0].value = 0;
        this.model = {
          nome: ""
        }
      },
      
      deleteItem: async function (even) {
        if (!this.dialogConfirmation) {
          this.dialogConfirmation = true;
          this.excluindo = even;
        } else {
          
          this.setLoading(true);
          await dividasCtrl.remove(even);
          this.dialogConfirmation = false;
          this.excluindo = null;
          await this.buscarDividas();
          this.setLoading(false);
        }
      },
      editItem: async function (even) {
        this.dialog = true;
        this.editando = true;
        this.model = {...even};
        this.model.internal = undefined;
        this.model.flags = undefined;
        // this.$refs.ValorDivida.$el.getElementsByTagName('input')[0].value = even.ValorDivida;
        // this.$refs.ValorEmpresa.$el.getElementsByTagName('input')[0].value = even.ValorEmpresa;
        
      },
      save: async function () {
        this.setLoading(true);
        let errors = await this.$validator.validate();
        console.log(errors);
        if (errors) {
          let res = await dividasCtrl.save(this.model);
          if (res.data && res.data.error) {
            this.message = res.data.error.data;
            this.dialogError = true;
          } else {
            this.clear();
            await this.buscarDividas();
          }
          
          this.setLoading(false);
          this.editando = false;
        }
      },
      clear: function () {
        this.model = {};
        this.editando = false;
        this.dialog = false;
        this.dialogNovo = false;
      },
      importCsv: async function (e) {
        let vm = this;
        if (window.FileReader) {
          var render = new FileReader();
          render.readAsText(e.target.files[0]);
          render.onload = function (event) {
            let csv = event.target.result;
            vm.parseCsv = csvJSON(csv);
          }
        }
      },
      getStatusDivida (divida) {
        if (divida && divida.ValorRepasse === 0) {
          return 'Quitado';
        }
        if (divida.StatusDivida == 1) {
          return 'Processo Cobrança';
        } else if (divida.StatusDivida == 2) {
          return 'Aguardando Aprovação';
        } else if (divida.StatusDivida == 3) {
          return 'Acordo Vigente';
        } else if (divida.StatusDivida == 4) {
          return 'Acordo em Atraso';
        } else if (divida.StatusDivida == 5) {
          return 'Divida Bloqueada';
        } else if (divida.StatusDivida == 6) {
          return 'Deslocalizado';
        } else if (divida.StatusDivida == 8) {
          return 'Bloqueado';
        }
      },
      importar: async function (importaCliente, dividasImport) {
        if (!importaCliente) {
          this.dialogError = true;
          this.message = "Cliente deve ser informado!";
          return;
        }
        if (!dividasImport || dividasImport.length <= 0) {
          this.dialogError = true;
          this.message = "Dividas devem ser informadas!";
          return;
        }
          
        this.setLoading(true);
        this.problemas = "";
        for await (const divida of dividasImport) {
          this.importarDividas(importaCliente, divida);
        }
        this.setLoading(false);
        if (this.problemas.length > 1) {
          this.dialogError = true;
          this.message = this.problemas;
        } else {
          this.dialogError = true;
          this.message = "Dividas importadas com sucesso!";
        }
        await this.buscarDividas();

      },
      async importarDividas(importaCliente, divida) {
        
        this.setLoading(true);
        if (!importaCliente) {
          this.dialogError = true;
          this.setLoading(false);
          this.message = "Cliente deve ser informado!";
          return;
        } 
        if (!divida.Nome) {
          
          this.dialogError = true;
          this.setLoading(false);
          this.message = "Nome deve ser informado!";
          return;
        } 
        if (!divida.CnpjCpf) {

          this.dialogError = true;
          this.setLoading(false);
          this.message = "CnpjCpf deve ser informado!";
          return;
        } 
        if (!divida.DataDivida) {

          this.dialogError = true;
          this.setLoading(false);
          this.message = "Data da Divida deve ser informado!";
          return;
        } 
        if (!divida.ValorDivida) {

          this.dialogError = true;
          this.setLoading(false);
          this.message = "Valor da Divida deve ser informado!";
          return;
        }
        if (!divida.Juros) {

          this.dialogError = true;
          this.setLoading(false);
          this.message = "Juros deve ser informado!";
          return;
        } 
        if (!divida.ValorEmpresa) {

          this.dialogError = true;
          this.setLoading(false);
          this.message = "Valor da Empresa deve ser informado!";
          return;
        }
        if (importaCliente && divida.Nome && divida.CnpjCpf && divida.DataDivida && divida.ValorDivida && divida.Juros && divida.ValorEmpresa) {
          console.log("divida");
          try {
            let devedor = {
              Nome: divida.Nome,
              CnpjCpf: divida.CnpjCpf,
              Endereco: divida.Endereco,
              DataNascimento: divida.DataNascimento,
              TelefonePrincipal: divida.telefone1,
              Telefone2: divida.telefone2,
              IsAtivo: true
            }

            console.log(devedor);
            devedor = await devedoresCtrl.save(devedor);

            let endereco = {
              cep: divida.cep,
              logradouro: divida.logradouro,
              numero: divida.numero,
              bairro: divida.bairro,
              localidade: divida.localidade,
              uf: divida.uf,
              hot: true,
              devedor: devedor._id
            }

            console.log(endereco);
            await enderecodeveCtrl.save(endereco);
            
            if (divida.telefone1) {
              
              let telefone1 = {
                telefone: divida.telefone1,
                hot: true,
                devedor: devedor._id
              }
              console.log("telefone1", telefone1);
              await telefonedeveCtrl.save(telefone1);
            }


            if (divida.telefone2) {
              let telefone2 = {
                telefone: divida.telefone2,
                hot: false,
                devedor: devedor._id
              }

              console.log(telefone2);
              await telefonedeveCtrl.save(telefone2);
            }
            if (divida.telefone3) {
              let telefone3 = {
                telefone: divida.telefone3,
                hot: false,
                devedor: devedor._id
              }

              console.log(telefone3);
              await telefonedeveCtrl.save(telefone3);
            }
            if (divida.email) {
              let email = {
                email: divida.email,
                hot: true,
                devedor: devedor._id
              }

              console.log(email);
              await emaildeve.save(email);
            }

            

            let dividaimp = {
              Identificador: divida.contrato,
              TipoProduto: divida.TipoProduto,
              TipoJuro: divida.TipoJuros,
              Especificacao: divida.Especificacao,
              DataDivida: divida.DataDivida,
              ValorDivida: divida.ValorDivida,
              Juros: divida.Juros,
              ValorEmpresa: divida.ValorEmpresa,
              StatusDivida: '1',
              Ativo: true,
              idcliente: importaCliente,
              iddevedor: devedor._id
            }

            console.log(dividaimp);
            await dividasCtrl.save(dividaimp);

          } catch (e) {
            this.problemas = this.problemas + e.message + " Linha sem valores: Nome " + divida.Nome + " CnpjCpf " + divida.CnpjCpf + " DataDivida " + divida.DataDivida + " ValorDivida " + divida.ValorDivida + " Juros " + divida.Juros + " ValorEmpresa: " + divida.ValorEmpresa;
            this.dialogError = true;
            this.setLoading(false);
            this.message = e.message;
            return;
          }
          
          this.dialogNovo = false;
        } else {
          this.problemas = this.problemas + "Linha sem valores: Nome " + divida.Nome + " CnpjCpf " + divida.CnpjCpf + " DataDivida " + divida.DataDivida + " ValorDivida " + divida.ValorDivida + " Juros " + divida.Juros + " ValorEmpresa: " + divida.ValorEmpresa;
        }
        
        this.setLoading(false);
      },
      async exportarExcel () {
        let data = [];
        let dividas = [];
        
        
        this.setLoading(true);
        if (this.user != null && this.user.acesso == "Cliente") {
          dividas = await dividasCtrl.getDividas2({cliente: this.user.cliente, filtros: this.filtros});
        } else {
          dividas = await dividasCtrl.getDividas2({filtros: this.filtros});
        }
        this.setLoading(false);


        dividas.forEach(divida => {
          let object = {}
          if (this.user.acesso == "Admin") {
            object = {
              "Contrato": divida.Identificador,
              "Empresa": divida.clienteNome,
              "Devedor": divida.devedorNome,
              "CPF": divida.devedorCnpjCpf,
              "Status Divida": this.getStatusDivida(divida),
              "Devedor Bloqueado": divida.devedorIsAtivo?'Não':'Sim',
              "Data Nascimento": divida.devedorDataNascimento,
              "Telefone 1": divida.telefones&&divida.telefones[0]?divida.telefones[0].telefone:'',
              "Telefone 2": divida.telefones&&divida.telefones[1]?divida.telefones[1].telefone:'',
              "Telefone 3": divida.telefones&&divida.telefones[2]?divida.telefones[2].telefone:'',
              "Especificação": divida.Especificacao,
              "Tipo Produto": divida.TipoProduto,
              "Juro": divida.Juros,
              "Tipo Juro": divida.TipoJuro,
              "Data da Divida": divida.DataDivida,
              "Valor Divida": divida.ValorDivida,
              "Valor Empresa": divida.ValorEmpresa
            };
          } else if (this.user.acesso == "Cliente") {
            object = {
              "Contrato": divida.Identificador,
              "Empresa": divida.clienteNome,
              "Devedor": divida.devedorNome,
              "CPF": divida.devedorCnpjCpf,
              "Status Divida": this.getStatusDivida(divida),
              "Devedor Bloqueado": divida.devedorIsAtivo?'Não':'Sim',
              "Data Nascimento": divida.devedorDataNascimento,
              "Especificação": divida.Especificacao,
              "Tipo Produto": divida.TipoProduto,
              "Data da Divida": divida.DataDivida,
              "Valor Divida": divida.ValorDivida
            };
          }
          
          
          data.push(object);
        });
        try {
            json2excel({
                data,
                name: 'dividas',
                formateDate: 'dd/mm/yyyy'
            });
        } catch (e) {
            console.error('export error');
        }
      },
      async exportarExcelTodas () {
        
        this.setLoading(true);
        let dividas = await dividasCtrl.getDividasAll();
        let data = [];
        dividas.forEach(divida => {
          let object = {
              "Contrato": divida.Identificador,
              "Empresa": divida.clienteNome,
              "Devedor": divida.devedorNome,
              "CPF": divida.devedorCnpjCpf,
              "Status Divida": this.getStatusDivida(divida),
              "Devedor Bloqueado": divida.devedorIsAtivo?'Não':'Sim',
              "Data Nascimento": divida.devedorDataNascimento,
              // "Endereço": divida.iddevedor?divida.iddevedor.Endereco:'',
              // "Telefone": divida.iddevedor?divida.iddevedor.TelefonePrincipal:'',
              "Especificação": divida.Especificacao,
              "Tipo Produto": divida.TipoProduto,
              "Juro": divida.Juros,
              "Tipo Juro": divida.TipoJuro,
              "Data da Divida": divida.DataDivida,
              "Valor Divida": divida.ValorDivida,
              "Valor Empresa": divida.ValorEmpresa
            };
          
          
          data.push(object);
        });
        try {
            json2excel({
                data,
                name: 'TodasDividas',
                formateDate: 'dd/mm/yyyy'
            });
          
          this.setLoading(false);
        } catch (e) {
          this.setLoading(false);
          console.error('export error');
        }
      },
      onFileChangePdf: async function ($event){
        this.setLoading(true);
        try {
          const files = $event.target.files || $event.dataTransfer.files;
          if (files) {
            var payload = new FormData();
            payload.set('divida', this.model._id);
            payload.set('tipo', "pdf");
            if (files.length > 0) {
              for (var i = 0; i < files.length; i++) {
                var file = files[i];
                payload.append('filename', file);
              }
              let res = await dividasCtrl.saveDividaImage(payload);
              
              this.model = await dividasCtrl.getDividaId(this.model._id);
              this.setLoading(false);
            }
          }
        } catch (e) {
          this.setLoading(false);

        }
      },
      
      async deleteImage (item) {
        this.setLoading(true);
        let res = await dividasCtrl.removeDividaImage(item, this.model._id);
        this.model = await dividasCtrl.getDividaId(this.model._id);
        
        this.setLoading(false);
      },
      getFiltered(e){
        console.log(e);
        this.filtered = e;
      },
      forceFileDownload(response){
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'file.pdf') //or any other extension
        document.body.appendChild(link)
        link.click()
      },
      downloadWithAxios(url){
        axios({
          method: 'get',
          url: url,
          responseType: 'arraybuffer'
        })
        .then(response => {
          
          this.forceFileDownload(response);
          
        })
        .catch(() => console.log('error occured'))
      },
      ...mapMutations({
        setLoading: "setLoading",
        setDevedor: "setDevedor",
      }),
    },
    directives: {money: VMoney}
  }
</script>


// WEBPACK FOOTER //
// src/pages/dividas/Dividas.vue